/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, {useState} from 'react';

import { ICheckoutTermsAndConditions, ICheckoutTermsAndConditionsError, ICheckoutTermsAndConditionsViewProps } from './absolute-terms-conditions';

import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

const TermsAndCondition: React.FC<ICheckoutTermsAndConditions> = ({
    termsAndConditionAcceptance,
    checkBox,
    description
}) => {

    return (
        <Node {...termsAndConditionAcceptance}>
            {checkBox}
            {description}
        </Node>
    );
};

const ErrorMessage: React.FC<ICheckoutTermsAndConditionsError> = ({
    error,
    title,
    message
}) => {

    return (
        <Node {...error}>
            {title}
            {message}
        </Node>
    );
};

const CheckoutTermsAndConditionsView: React.FC<ICheckoutTermsAndConditionsViewProps> = props => {
    const {
        checkoutTermsAndConditions,
        viewState,
        termsAndConditionsContent,
        errorMessage,
        saveButton,
        editButton,
        cancelButton,
        termsTitle, 
        termsContent
    } = props;
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    return (

        // TODO: All wrapper div should be provided by viewProps. Once SDK provide the sln, update markup.
        <Module {...checkoutTermsAndConditions}>
            {viewState.isError && errorMessage && <ErrorMessage {...errorMessage} />}
            <TermsAndCondition {...termsAndConditionsContent} />
            <Button color="warning" onClick={toggle}>View Terms</Button>
            <Modal isOpen={modal} toggle={toggle} className='ab-terms' >
                <ModalHeader toggle={toggle}>{termsTitle}</ModalHeader>
                <ModalBody className="inside-xl">
                    <div>
                        {termsContent}
                    </div>
                </ModalBody>
            </Modal>
            {viewState.isShowSaveButton && saveButton}
            {viewState.isShowEditButton && editButton}
            {viewState.isShowCancelButton && cancelButton}
        </Module>
    );
};

export default CheckoutTermsAndConditionsView;
